import { create } from "zustand"
import { persist } from "zustand/middleware"

export type Locale = "es" | "ca" | "en"

interface LocaleState {
	locale: Locale
	isLoading: boolean
}

interface LocaleActions {
	setLocale: (locale: Locale) => void
	getLocaleFromUser: () => Locale
	setLoading: (loading: boolean) => void
	clearAllData: () => void
}

type LocaleStore = LocaleState & LocaleActions

export const useLocaleStore = create<LocaleStore>()(
	persist(
		(set, get) => ({
			// Initial state
			locale: "ca",
			isLoading: false,

			// Actions
			setLocale: (locale: Locale) => {
				set({ locale })
			},

			getLocaleFromUser: (): Locale => {
				const { locale } = get()
				return locale
			},

			setLoading: (loading: boolean) => {
				set({ isLoading: loading })
			},

			clearAllData: () => {
				// Reset to default locale
				set({
					locale: "ca",
					isLoading: false,
				})
				// Clear persisted data from localStorage
				if (typeof window !== "undefined") {
					localStorage.removeItem("locale-store")
				}
			},
		}),
		{
			name: "locale-store",
			partialize: (state) => ({
				locale: state.locale,
			}),
		}
	)
)
